import React, { useState } from "react";
import { Form, Input, Select, Row, Col, Card, InputNumber, Button, Table } from "antd";

const { Option } = Select;

const BarangDetail = () => (
    <Form layout="vertical">
        <Row gutter={24}>
            <Col span={8}>
                <Card title="Jenis" bordered={true}>
                    <Form.Item label="Seri">
                        <Input value="1" disabled />
                    </Form.Item>
                    <Form.Item label="Pos Tarif / HS">
                        <Select placeholder="Pilih Pos Tarif">
                            <Option value="12345678">12345678 - CONTOH BARANG</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="Uraian Jenis Barang">
                        <Input.TextArea rows={2} placeholder="Uraian Jenis Barang" />
                    </Form.Item>
                    <Form.Item label="Merk">
                        <Input placeholder="Merk" />
                    </Form.Item>
                    <Form.Item label="Tipe">
                        <Input placeholder="Tipe" />
                    </Form.Item>
                    <Form.Item label="Ukuran">
                        <Input placeholder="Ukuran" />
                    </Form.Item>
                    <Form.Item label="Spesifikasi Lain">
                        <Input placeholder="Spesifikasi Lain" />
                    </Form.Item>
                </Card>
            </Col>
            <Col span={8}>
                <Card title="Keterangan Lainnya" bordered={true}>
                    <Form.Item label="Negara">
                        <Select placeholder="Pilih Negara">
                            <Option value="ID">INDONESIA</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="Kategori Barang">
                        <Select placeholder="Pilih Kategori">
                            <Option value="UMUM">UMUM</Option>
                        </Select>
                    </Form.Item>
                </Card>
                <Card title="Harga" bordered={true} style={{ marginTop: 20 }}>
                    <Form.Item label="Amount Nilai (CIF)">
                        <InputNumber style={{ width: "100%" }} placeholder="0.00" />
                    </Form.Item>
                </Card>
            </Col>
            <Col span={8}>
                <Card title="Jumlah & Berat" bordered={true}>
                    <Form.Item label="Jumlah dan Satuan Barang">
                        <Input.Group compact>
                            <InputNumber style={{ width: '40%' }} placeholder="0.0000" />
                            <Select style={{ width: '60%' }} placeholder="Pilih Satuan">
                                <Option value="KGM">KGM - KILOGRAM</Option>
                            </Select>
                        </Input.Group>
                    </Form.Item>
                    <Form.Item label="Berat Bersih (Kg)">
                        <InputNumber style={{ width: "100%" }} placeholder="0.0000" />
                    </Form.Item>
                    <Form.Item label="Kemasan">
                        <Input.Group compact>
                            <InputNumber style={{ width: '40%' }} placeholder="0" />
                            <Select style={{ width: '60%' }} placeholder="Pilih Kemasan">
                                <Option value="CT">CT - CARTON</Option>
                            </Select>
                        </Input.Group>
                    </Form.Item>
                </Card>
                <Card title="Dokumen Fasilitas/Lartas" bordered={true} style={{ marginTop: 20 }} extra={<Button type="primary" size="small">Tambah</Button>}>
                    <Table columns={[{ title: "Seri", dataIndex: "seri" }, { title: "Jenis", dataIndex: "jenis" }]} dataSource={[]} pagination={false} size="small" />
                </Card>
            </Col>
        </Row>
        <Row justify="end" style={{ marginTop: 20 }}>
            <Button style={{ marginRight: 8 }}>Simpan</Button>
            <Button type="danger">Tutup</Button>
        </Row>
    </Form>
);

const Barang = ({ data, setData }) => {
    const [view, setView] = useState("list"); // 'list' or 'detail'

    if (view === "detail") {
        return <BarangDetail />;
    }

    return (
        <div>
            <Button type="primary" onClick={() => setView("detail")} style={{ marginBottom: 20 }}>
                Tambah Barang
            </Button>
            <Table
                columns={[
                    { title: "Seri", dataIndex: "seri" },
                    { title: "HS Code", dataIndex: "hsCode" },
                    { title: "Uraian", dataIndex: "uraian" },
                    { title: "Jumlah", dataIndex: "jumlah" },
                    { title: "Satuan", dataIndex: "satuan" },
                ]}
                dataSource={[]}
            />
        </div>
    );
};

export default Barang;
